export default __webpack_public_path__ + "static/media/Thwack.aea19cdf.svg";